export const Pages = {
  // System
  ROOT: '/',
  AUTH_CALLBACK: '/callback',
  NO_PERMISSIONS: '/wait',
  NOT_AUTHORIZED: '/not-authorized',
  NOT_FOUND: 'not-found',
  CHANGE_PASSWORD: 'profile/change-password',
  ONBOARDING: '/onboarding',
  ORGANIZATIONS: '/organizations',
  SETUP_API_KEYS: '/setup-api-keys',
  EMPLOYEES_PART: 'employees',
  ADMIN_ORGANIZATION_PART: 'admin',
  ADMIN_SERVICE: '/admin',
  REFERENCE_BOOKS: 'reference-books',
  USERS: 'users',
  WORKING_PERIODS: 'working-periods',
  COUNTERPARTIES: 'counterparties',
  API_KEYS: 'api-keys',
  LLM_PROVIDER_CONFIGURATION: 'llm-provider-configuration',
  LLM_USAGE: 'llm-usage',
  BI_DASHBOARDS: 'bi-dashboards',
  MCP_SERVERS: 'mcp-servers',
  MCP_CONNECTIONS: 'mcp-connections',
  // Not `agents`: nginx and vite proxy /agents/* to the agents service (test chat, GSB-7658), so a reload of
  // /agents or /agents/{id} would never reach this SPA (GSB-7710).
  AGENTS: 'ai-agents',
  AGENT_ROLES: 'agent-roles',
  SKILLS: 'skills',
  // Free of the proxied prefixes (/api, /agents) of nginx and vite, so a reload reaches this SPA (GSB-7710).
  KNOWLEDGE: 'knowledge',
} as const;

export type Pages = (typeof Pages)[keyof typeof Pages];
